import { FC } from 'react';
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom';
import { Typography, Grid, Box } from '@mui/material';
import { common } from '@mui/material/colors';
import { ResourceEditContainer, SimpleForm } from '@prismamedia/one-crud-react';
import { Campaign } from '__generated__/queries-newsletter';
import { paths, replaceParams } from 'routing';
import { CircularLoader } from 'components/CircularLoader';
import { RoutingTabs } from 'components/RoutingTabs';
import { AppBar } from './AppBar';
import { UPSERT_CAMPAIGN_MUTATION } from 'apollo/mutations/upsertCampaign.newsletter.graphql';
import { CampaignConfig } from 'pages/configs/campaign.config';
import { GET_CAMPAIGN_QUERY } from 'apollo/queries/getCampaign.newsletter.graphql';
import { Generalities } from 'pages/CampaignPage/CampaignEditPage/Generalities';
import { ContentPage } from 'pages/CampaignPage/CampaignEditPage/ContentPage';
import { useQueryParams } from 'utils/useUriHelpers';
import { afterFetch } from './utils';

export const CampaignEditPage: FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{ id: string }>();
  const isCreate = match.path === paths.CAMPAIGN_NEW;
  const isDuplicate = match.path.includes('duplicate');
  const { queryParams } = useQueryParams<{
    brand: string | null;
  }>({
    brand: null,
  });
  const brandQueryParam = queryParams.brand
    ? `?brand=${queryParams.brand}`
    : '';

  return (
    <Box mt={8} sx={{ backgroundColor: common.white }}>
      <RoutingTabs
        tabs={[
          {
            label: 'CONFIGURATION GÉNÉRALE',
            location: {
              pathname: `${match.url}/generalities`,
            },
          },
          {
            label: 'CONTENUS',
            location: {
              pathname: `${match.url}/content`,
            },
          },
        ]}
      />
      <ResourceEditContainer
        mutationProps={{
          mutation: UPSERT_CAMPAIGN_MUTATION,
          onCompleted: (data) => {
            if (!isCreate || !data.upsertCampaign || !data.upsertCampaign.id) {
              return;
            }
            history.push(
              `${replaceParams(paths.CAMPAIGN_EDIT, {
                id: data.upsertCampaign.id,
              })}${brandQueryParam}`,
            );
          },
        }}
        resourceConfig={CampaignConfig}
        query={GET_CAMPAIGN_QUERY}
        isCreate={isCreate}
        variables={{
          where: {
            id: match.params.id,
          },
        }}
        messages={{
          loading: <CircularLoader fullScreen />,
          error: <Typography>Une erreur est survenue.</Typography>,
          nocontent: <Typography>Aucune données.</Typography>,
        }}
        afterFetch={afterFetch(isDuplicate)}
        fetchPolicy="network-only"
      >
        {({ item, onSave }) => (
          <SimpleForm
            style={{
              boxShadow: 'none',
              padding: 0,
              background: 'none',
            }}
          >
            <AppBar
              brand={queryParams.brand}
              isCreate={isCreate || isDuplicate}
              onSave={onSave}
              id={match.params.id}
              item={item as Campaign}
            />
            <Grid
              container
              spacing={2}
              sx={{
                margin: 0,
                width: '100%',
              }}
            >
              <Switch>
                <Route
                  path={`${match.url}/generalities`}
                  render={() => <Generalities />}
                />
                <Route
                  path={`${match.url}/content`}
                  render={() => <ContentPage />}
                />
              </Switch>
            </Grid>
          </SimpleForm>
        )}
      </ResourceEditContainer>
    </Box>
  );
};
